
import classNames from 'classnames';
import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import { EmvioButton } from '@nexio/emvio-form-components';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';

import { toastIfError } from '../../../utils/toast';
import Modal from '../../Modal/Modal';
import { toggleModal } from '../../Modal/modalActions';
import { uploadPayoutBatch } from '../payoutsActions';
import { getIsPayoutBatchUploading, getPayoutBatchErrorMessage, getWasBatchUploadSuccessful } from '../payoutsEntity';
import './UploadPayouts.scss';

const MAX_FILE_SIZE_LIMIT = 5918592;

const uniqueModalName = 'uploadPayouts';

export class UploadPayouts extends Component {
    static propTypes = {
        uploadBatch: PropTypes.func.isRequired,
        onToggleModal: PropTypes.func.isRequired,
        wasBatchUploadedSuccessful: PropTypes.bool,
        isUploading: PropTypes.bool,
        batchUploadErrorMessage: PropTypes.string
    };

    constructor(props) {
        super(props);

        this.state = {
            file: null
        };
    }

    componentDidUpdate(prevProps) {
        toastIfError(prevProps, this.props, 'batchUploadErrorMessage', 'Failed to upload payout batch.');

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'wasBatchUploadedSuccessful') && this.props.wasBatchUploadedSuccessful) {
            toast('Payout batch uploaded successfully.', { type: 'success' });
            setTimeout(() => {
                this.props.onToggleModal();

                this.setState({ file: null });
            }, 500);
        }
    }

    handleOnSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.props.uploadBatch(this.state.file);
    };

    getTotalFileSize = () => {
        return _.get(this.state, 'file.size');
    };

    removeFile = () => {
        this.setState({ file: null });
    };

    onDrop = (acceptedFiles, rejectedFiles) => {
        if (!_.isEmpty(rejectedFiles)) {
            toast('Invalid file', { type: 'error' });
        }

        this.setState({
            file: acceptedFiles[0]
        });
    };

    onOpenFileDialog = () => {
        this.dropzoneRef.open();
    };

    renderFile = () => {
        if (this.state.file) {
            const { file } = this.state;
            window.URL.revokeObjectURL(file.preview);

            return (
                <div className="file" key={file.name}>
                    <div className="file-name">{file.name}</div>
                    <button type="button" className="delete-item-button" onClick={this.removeFile}>
                        <span className="icon-close" />
                    </button>
                </div>
            );
        }
    };

    render = () => {
        const isFileTooBig = this.getTotalFileSize() > MAX_FILE_SIZE_LIMIT;

        const fileUploadSizeClassNames = classNames('', { 'error': isFileTooBig });

        return (
            <Modal uniqueModalName={uniqueModalName} title="Upload Payout Batch File">
                <div className="emvio-upload-payouts">
                    <Dropzone
                        multiple={false}
                        accept=".csv"
                        className="file-upload-container"
                        disableClick
                        name="files"
                        onDrop={this.onDrop}
                        ref={(node) => {
                            this.dropzoneRef = node;
                        }}>
                        <div className="file-upload-label">
                            <div>Drag file here to upload</div>
                            <div>or</div>
                        </div>
                        <EmvioButton className="file-upload-button"
                            type="button"
                            onClick={this.onOpenFileDialog}>
                            Browse File
                        </EmvioButton>
                    </Dropzone>
                    <EmvioButton className="file-upload-button mobile"
                        type="button"
                        onClick={this.onOpenFileDialog}>
                        Browse File
                    </EmvioButton>
                    <div className="file-upload-caption">
                        <div>Accepted file format: CSV</div>
                        <div className={fileUploadSizeClassNames}>Maximum filesize: 6.0 MB</div>
                    </div>
                    {this.renderFile()}
                    <div className="button-row">
                        <EmvioButton
                            className="submit-button"
                            ref={(button) => {
                                this.submitButtonRef = button;
                            }}
                            title={isFileTooBig ? 'File size limit exceeded' : ''}
                            disabled={!this.state.file || isFileTooBig}
                            invertColors={true}
                            onClick={this.handleOnSubmit}
                            isLoading={this.props.isUploading}
                        >
                            Submit
                        </EmvioButton>
                    </div>
                </div>
            </ Modal>
        );
    };
}

function mapStateToProps(state) {
    return {
        batchUploadErrorMessage: getPayoutBatchErrorMessage(state),
        wasBatchUploadedSuccessful: getWasBatchUploadSuccessful(state),
        isUploading: getIsPayoutBatchUploading(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onToggleModal: () => dispatch(toggleModal(uniqueModalName)),
        uploadBatch: (csv) => dispatch(uploadPayoutBatch(csv))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadPayouts);
